<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="480px"
    @close="$router.replace('/data/manufacturers')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="manufacturer"
      :rules="rules"
      ref="manufacturerForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="store"
    >
      <el-form-item
        prop="name"
        label="Név"
      >
        <el-input v-model="manufacturer.name" />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/data/manufacturers')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="store"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['type', 'manufacturerId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        manufacturer: {},
        rules: {
          name: [
            { required: true, message: 'Név megadása kötelező', trigger: 'change'}
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új gyártó';
        } else if (this.type === 'update') {
          return 'Gyártó módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    methods: {
      async store() {
        this.$refs['manufacturerForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('manufacturer/create', this.manufacturer);
              } else if (this.type === 'update') {
                await this.$store.dispatch('manufacturer/update', this.manufacturer);
              }
              this.$store.dispatch('manufacturer/fetchAllWithPagination');
              this.buttonLoading = false;
              this.$router.replace('/data/manufacturers');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      },
    },
    async mounted() {
      this.loading = true;
      if (this.manufacturerId) {
        this.manufacturer = await this.$store.dispatch('manufacturer/fetch', this.manufacturerId);
      }
      this.loading = false;
    }
  };
</script>
